import React from 'react';
import Button from './Button';

const TeaserItem = ({ item }) => (
    <div style={{paddingTop: '30px', margin: '15px'}}>
        <i className={item.iconName}></i>
        <h5 style={{ margin: '5px 0px 10px 0' }}>{item.title}</h5>
        <p style={textStyle}>
            {item.text}
        </p>
        {item.link ?
            <Button targetUrl={item.link} style={{ height: '35px', fontSize: '18px', backgroundColor: 'Transparent' }} /> : null}
    </div>
);

const textStyle = { margin: 0, fontSize: '18px', margin: '5px 0px 0px 0' };

export default TeaserItem;


// WEBPACK FOOTER //
// ./src/components/TeaserItem.js